import { AvatarDropdown, AvatarName /** Question */ /** SelectLang */ } from '@/components';
import Exception403 from '@/components/Exception403';
import { getUserInfo } from '@/services/common';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { PageLoading, SettingDrawer } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import React from 'react';
import defaultSettings from '../config/defaultSettings';
import { requestConfig } from './requestConfig';
import { getInitPath, TOKEN_STORIGE_KEY } from './constants';
import { loadScript } from '@/utils/common';
import { getItem } from './utils';
import BindPhone from '@/components/BindPhone';

const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/login';

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  userInfo?: API.UserInfo;
  roleInfo?: API.RoleInfo;
  noReadmessageNum?: number;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.User | undefined>;
  fetchNoReadMessageNum?: () => Promise<number | undefined>;
}> {
  const fetchUserInfo = async () => {
    const { data } = await getUserInfo({ skipErrorHandler: true });
    return data;
  };
  const fetchNoReadMessageNum = async (): Promise<number | undefined> => undefined;
  // 如果不是登录页面，执行
  const { location } = history;
  

  if (location.pathname !== loginPath) {
    const token = getItem(TOKEN_STORIGE_KEY);
    if (!token) {
       history.replace({
        pathname: '/login',
      });
      return {
        settings: defaultSettings as Partial<LayoutSettings>,
      }
    }
    let userData = {} as any;
    try {
      userData = await fetchUserInfo();
    } catch (error) {
      console.log(error);
    }
    return {
      fetchUserInfo,
      userInfo: { ...userData },
      roleInfo: { permissions: userData.permissions || [] },
      settings: defaultSettings as Partial<LayoutSettings>,
      fetchNoReadMessageNum,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
    fetchNoReadMessageNum,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  const goFirstAccess = () => {
    const permissions = initialState?.roleInfo?.permissions;
    const path = getInitPath(permissions || []);
    if (path) {
      history.push(path);
    }
  };

  // 高德地图的2个sdk js
  // loadScript({
  //   id: 'amapmaps1.4.15',
  //   url: 'https://webapi.amap.com/maps?v=1.4.15&key=d0434e299764e8cd3ba9ef22ba45d729&plugin=AMap.Autocomplete,AMap.Geocoder',
  // });
  // 许方艺
  //  loadScript({
  //   id: 'amapmaps1.4.15',
  //   url: 'https://webapi.amap.com/maps?v=1.4.15&key=cae86a6c79a65fd3040c3d427aec1c69&plugin=AMap.Autocomplete,AMap.Geocoder',
  // });
  // 徐勤康
   loadScript({
    id: 'amapmaps1.4.15',
    url: 'https://webapi.amap.com/maps?v=1.4.15&key=617ec5aa9692e6deed1f245f8c950656&plugin=AMap.Autocomplete,AMap.Geocoder',
  });
  //胡培崧
  loadScript({ id: 'amapmapsaddToolbar', url: 'https://cache.amap.com/lbs/static/addToolbar.js' });
  return {
    actionsRender: () => [
      <BindPhone key='BindPhone' />
      // <Alert key="alert" />,
      /** <Question key="doc" /> */
      /** <SelectLang key="SelectLang" />, */
      // <Message key="Message" />,
    ],
    avatarProps: {
      src: initialState?.userInfo?.avatar ? (
        initialState?.userInfo?.avatar
      ) : (
        <div className="nav-user-avatr" />
        // <Avatar style={{ backgroundColor: initialState?.settings?.colorPrimary }}>
        //   {getFirstChar(initialState?.userInfo?.name)}
        // </Avatar>
      ),
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      // content: initialState?.userInfo?.name,
    },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      // 页面切换时执行
    },
    bgLayoutImgList: [
      // {
      //   src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
      //   left: 85,
      //   bottom: 100,
      //   height: '303px',
      // },
      // {
      //   src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
      //   bottom: -68,
      //   right: -45,
      //   height: '303px',
      // },
      // {
      //   src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
      //   bottom: 0,
      //   left: 0,
      //   width: '331px',
      // },
    ],
    links: [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    unAccessible: (
      <Exception403 />
      // <Result
      //   status="warning"
      //   title="您暂时没有当前权限，请联系管理员"
      //   extra={
      //     <Button
      //       type="primary"
      //       key="console"
      //       onClick={() => {
      //         goFirstAccess();
      //       }}
      //     >
      //       返回首页
      //     </Button>
      //   }
      // />
    ),
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...requestConfig,
};
